
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.974 10.73c-.779 2.738-1.421 5.037-1.473 5.349a.65.65 0 01-.22.41.666.666 0 01-.441.16h-.074a.664.664 0 01-.44-.24.647.647 0 01-.14-.477c.029-.257.55-2.15 1.188-4.402-.901.414-1.642.682-2.098.738-.074.01-.148.015-.222.015-.447 0-.672-.21-.784-.396a.645.645 0 01.088-.772.663.663 0 01.775-.14c.392-.054 1.398-.462 2.719-1.138a1599.3 1599.3 0 011.689-5.873.654.654 0 01.316-.379.669.669 0 01.887.25.64.64 0 01.066.487c-.405 1.4-.877 3.035-1.334 4.633a40.75 40.75 0 001.78-1.074c3.3-2.106 5.548-4.119 6.001-5.402.171-.48.046-.7-.195-.885-.578-.443-2.356-.498-5.613.675C7.57 4.026 2.414 7.44 1.921 9.22c.05.009.102.014.153.013a.669.669 0 01.648.368.645.645 0 01-.331.879.668.668 0 01-.257.054c-.14.007-.861.017-1.28-.473a1.189 1.189 0 01-.237-1.053c.329-1.52 2.43-3.183 4.134-4.32a35.25 35.25 0 017.25-3.642C14.33.202 17.412-.558 18.877.563c.683.527.93 1.28.698 2.134-.3 1.102-1.622 3.044-6.215 6.03a46.561 46.561 0 01-3.386 2.003zm8.283 7.966H2.047V20h16.21v-1.303zM13.36 16.78c-.577 0-.916-.372-.916-1.017 0-.646.508-1.017.916-1.017.407 0 .948.339.948 1.017 0 .678-.508 1.017-.948 1.017z","fill":"#161F32"}})])
          )
        }
      }
    